/* eslint-disable no-unused-vars */
import axios from "../../axios";

export default {
  namespaced: true,
  state: {
    plans: [],
    rules: [],
  },
  mutations: {
    SET_PLANS(state, data) {
      state.plans = data;
    },
    SET_RULES(state, data) {
      state.rules = data;
    },
  },
  actions: {
    async getAllPlans({ commit }, { query }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`tuition-fee-plans?${new URLSearchParams(query)}`)
          .then((response) => {
            commit("SET_PLANS", response.data.data);
            resolve(response);
          });
      });
    },
    async getAllRules({ commit }, { query }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`tuition-fee-plan-rules?${new URLSearchParams(query)}`)
          .then((response) => {
            commit("SET_RULES", response.data.data);
            resolve(response);
          });
      });
    },
    async getPlans({ commit }, { tuition_fee_id, query }) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `tuition-fees/${tuition_fee_id}/plans?${new URLSearchParams(query)}`
          )
          .then((response) => {
            commit("SET_PLANS", response.data.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async getRules({ commit }, { plan_id, query }) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `tuition-fee-plans/${plan_id}/rules?${new URLSearchParams(query)}`
          )
          .then((response) => {
            commit("SET_RULES", response.data.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async duplicateTuitionFee({ commit }, { tuition_fee_id, rule }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`tuition-fees/${tuition_fee_id}/duplicate`, rule)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  getters: {},
};
